var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "mdfeFormCard" },
      [
        _c(
          "el-form",
          {
            ref: "step3",
            attrs: { model: _vm.selectedTagForm, "label-position": "top" },
          },
          [
            _c(
              "el-card",
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("mdfeTranslate.AbnormalMdfe") } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: _vm.$t("placeOrder.pleaseInput") },
                      model: {
                        value: _vm.mdfeKey,
                        callback: function ($$v) {
                          _vm.mdfeKey = $$v
                        },
                        expression: "mdfeKey",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("el-card", { staticClass: "box-card" }, [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v(_vm._s(_vm.$t("mdfeTranslate.DriverAndVehicle"))),
                  ]),
                ]
              ),
              _c(
                "div",
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("collectionCenter.driver1"),
                                prop: "selectedDriver",
                                rules: {
                                  required: true,
                                  message: _vm.$t("GlobalSetObj.pleaseChoose"),
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "formTable",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "placeOrder.pleaseChoose"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                    "remote-method": _vm.getDriverInfo,
                                  },
                                  on: {
                                    "visible-change": _vm.handleDriverInfo,
                                  },
                                  model: {
                                    value: _vm.selectedTagForm.selectedDriver,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedTagForm,
                                        "selectedDriver",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectedTagForm.selectedDriver",
                                  },
                                },
                                _vm._l(_vm.driverList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.driverName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "collectionCenter.licensePlateNumber"
                                ),
                                prop: "vehiclePlate",
                                rules: {
                                  required:
                                    _vm.selectedTagForm.selectedDriverItem
                                      .length === 0,
                                  message: _vm.$t("collectionCenter.notNull"),
                                  trigger: ["change"],
                                },
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("placeOrder.pleaseInput"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.selectedTagForm.vehiclePlate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selectedTagForm,
                                      "vehiclePlate",
                                      $$v
                                    )
                                  },
                                  expression: "selectedTagForm.vehiclePlate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "div",
                      { staticStyle: { flex: "1", "padding-right": "5px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.addDriver },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("mdfeTranslate.ChooseVehicleAndDriver")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { flex: "1", "padding-left": "5px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { size: "small", type: "danger" },
                            on: { click: _vm.deleteAllDriver },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("mdfeTranslate.DeleteAll")) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "margin-bottom": "10px",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("mdfeTranslate.SelectedDriver")))]
                    ),
                  ]),
                  _vm.selectedTagForm.selectedDriverItem.length > 0
                    ? _c(
                        "div",
                        {
                          key: _vm.selectedTagFormKey,
                          staticStyle: { display: "flex" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                flex: "1",
                                padding: "10px",
                                border: "1px solid #ccc",
                                "border-radius": "5px",
                                "margin-right": "10px",
                                height: "300px",
                                "overflow-y": "auto",
                              },
                            },
                            _vm._l(
                              _vm.selectedTagForm.selectedDriverItem,
                              function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticStyle: { "margin-bottom": "10px" },
                                  },
                                  [
                                    index === 0
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              color: "black",
                                              "font-weight": "bold",
                                              height: "50px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.name) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          border: "1px solid #ccc",
                                          "border-radius": "5px",
                                          padding: "6px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { flex: "1" } },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "collectionCenter.compellation"
                                                  )
                                                ) +
                                                  ": " +
                                                  _vm._s(item.name)
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mdfeTranslate.document"
                                                  )
                                                ) +
                                                  "(CPF/CNPJ): " +
                                                  _vm._s(item.cpf)
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticStyle: { width: "50px" } },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "danger",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteDriver(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                flex: "1",
                                padding: "10px",
                                border: "1px solid #ccc",
                                "border-radius": "5px",
                                "margin-left": "10px",
                              },
                            },
                            [
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "font-weight": "bold",
                                      height: "50px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.vehicleInformation
                                          .licensePlateNumber
                                      )
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("GlobalSetObj.licensePlateNumber")
                                    ) +
                                      ": " +
                                      _vm._s(
                                        _vm.vehicleInformation
                                          .licensePlateNumber
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("mdfeTranslate.TrailerRENAVAM")
                                    ) +
                                      ": " +
                                      _vm._s(
                                        _vm.vehicleInformation.TrailerRENAVAM
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("mdfeTranslate.TrailerTare")
                                    ) +
                                      ": " +
                                      _vm._s(_vm.vehicleInformation.TrailerTare)
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("mdfeTranslate.TrailerCapacity")
                                    ) +
                                      ": " +
                                      _vm._s(
                                        _vm.vehicleInformation.TrailerCapacity
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("mdfeTranslate.TrailerRNTRC")
                                    ) +
                                      ": " +
                                      _vm._s(
                                        _vm.vehicleInformation.TrailerRNTRC
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("mdfeTranslate.TruckDocuments")
                                    ) +
                                      ": " +
                                      _vm._s(
                                        _vm.vehicleInformation.TrailerDocuments
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    "IE: " + _vm._s(_vm.vehicleInformation.ie)
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.$t("mdfeTranslate.State")) +
                                      ": " +
                                      _vm._s(_vm.vehicleInformation.State)
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.$t("mdfeTranslate.WheelKind")) +
                                      ": " +
                                      _vm._s(_vm.vehicleInformation.WheelKind)
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("mdfeTranslate.VehicleType")
                                    ) +
                                      ": " +
                                      _vm._s(_vm.vehicleInformation.vehicleType)
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _c(
          "el-card",
          { staticClass: "box-card" },
          [
            _c(
              "el-form",
              {
                ref: "step4",
                attrs: { model: _vm.selectedTagForm, "label-position": "top" },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "appendTag",
                            attrs: {
                              label: _vm.$t("mdfeTranslate.TrailerPlateNumber"),
                              prop: "veicReboque",
                            },
                          },
                          [
                            _c(
                              "el-input",
                              {
                                staticStyle: { width: "500px" },
                                attrs: {
                                  placeholder: _vm.$t("placeOrder.pleaseInput"),
                                },
                                model: {
                                  value: _vm.selectedTagForm.veicReboque,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selectedTagForm,
                                      "veicReboque",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "selectedTagForm.veicReboque",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _c("i", {
                                    staticClass: "el-icon-circle-plus-outline",
                                    staticStyle: { "font-size": "26px" },
                                    on: { click: _vm.addVeicReboque },
                                  }),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: { "font-weight": "bold", "margin-bottom": "10px" },
              },
              [_vm._v(_vm._s(_vm.$t("mdfeTranslate.SelectedVehicles")))]
            ),
            _vm.veicReboqueList.length > 0
              ? _c(
                  "div",
                  { staticClass: "driver-container" },
                  _vm._l(_vm.veicReboqueList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "driver-item",
                        class: _vm.getColSpan(
                          index,
                          _vm.veicReboqueList.length
                        ),
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "black",
                              "font-weight": "bold",
                              height: "50px",
                            },
                          },
                          [
                            _vm._v(_vm._s(item.licensePlateNumber) + " "),
                            _c(
                              "div",
                              { staticStyle: { float: "right" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteVeicReboque(index)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-delete" })]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c("div", [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.Proprietário")) +
                                ": " +
                                _vm._s(item.providerName)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("GlobalSetObj.licensePlateNumber")
                              ) +
                                ": " +
                                _vm._s(item.licensePlateNumber)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.document")) +
                                "(CPF/CNPJ): " +
                                _vm._s(item.driverDocument)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.TrailerRENAVAM")) +
                                ": " +
                                _vm._s(item.TrailerRENAVAM)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.TrailerTare")) +
                                ": " +
                                _vm._s(item.TrailerTare)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.TrailerCapacity")) +
                                ": " +
                                _vm._s(item.TrailerCapacity)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.TrailerRNTRC")) +
                                ": " +
                                _vm._s(item.TrailerRNTRC)
                            ),
                          ]),
                          _c("div", [_vm._v("IE: " + _vm._s(item.ie))]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.State")) +
                                ": " +
                                _vm._s(item.State)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.VehicleType")) +
                                ": " +
                                _vm._s(item.vehicleType)
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticStyle: { "margin-top": "10px", "text-align": "right" } },
      [
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.submitAbnormal } },
          [_vm._v(" " + _vm._s(_vm.$t("collectionCenter.Confirm")) + " ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }